const COLUMNS = [
  {
    label: '编码',
    show: true,
    key: 'field',
    width: 100
  },
  {
    label: '名称',
    show: true,
    key: 'fieldName',
    width: 150
  }
]

export default {
  props: {
    type: String,
    data: Array
  },
  data () {
    return {
      form: {
        applyRemark: '',
        decryptList: []
      },
      rules: {
        decryptList: [
          { type: 'array', required: true, message: '请选择解密字段', trigger: 'change' }
        ],
        applyRemark: [
          { required: true, message: '请输入申请说明', trigger: 'change' }
        ],
      },
    }
  },
  methods: {
    selectionChange (val) {
      this.form.decryptList = val
      this.$refs.form.validateField('decryptList')
    },
    onInput (val) {
      this.form.applyRemark = val
    },
    validate () {
      return this.$refs.form.validate()
    },
    getFormData () {
      return this.form
    }
  },
  render (h) {
    const { data } = this.$props
    const { form, rules } = this
    return (
      <div class="kye-data-export-decrypt-list">
        <el-form label-width="65px" ref="form" model={form} rules={rules}>
          <el-form-item label="解密字段" prop="decryptList">
            <kye-table2 columns={COLUMNS} data={data} showSelection on-selection-change={this.selectionChange}></kye-table2>
          </el-form-item>
          <el-form-item label="申请说明" prop="applyRemark">
            <kye-textarea maxLength={200} value={form.value} onInput={this.onInput}></kye-textarea>
          </el-form-item>
        </el-form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-export/components/form.js